const wwwUrl = import.meta.env.VITE_WWW || "https://www.mixitone.com";

/** Public marketing page with macOS / Windows installers. */
export const desktopAppDownloadUrl = `${wwwUrl}/download`;
